<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import RedhostingMeetAPI from 'dashboard/api/redhostingMeet';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  conversationId: { type: Number, required: true },
});

const { t } = useI18n();
const isLoading = ref(false);
const isEnabled = window.chatwootConfig.redhostingMeetEnabled === 'true';

// The tab opens on the click itself so the browser doesn't block it as a popup.
const startMeeting = async () => {
  isLoading.value = true;
  const meetingTab = window.open('', '_blank');
  try {
    const { data } = await RedhostingMeetAPI.createMeeting(
      props.conversationId
    );
    if (meetingTab) meetingTab.location.href = data.url;
    useAlert(t('REDHOSTING_MEET.INVITE_SENT'));
  } catch (error) {
    meetingTab?.close();
    useAlert(error?.response?.data?.error || t('REDHOSTING_MEET.CREATE_ERROR'));
  } finally {
    isLoading.value = false;
  }
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <NextButton
    v-if="isEnabled"
    v-tooltip.top-end="t('REDHOSTING_MEET.START_TOOLTIP')"
    icon="i-lucide-video"
    slate
    faded
    sm
    :is-loading="isLoading"
    @click="startMeeting"
  />
</template>
